export default __webpack_public_path__ + "static/media/ayalon2.e73d9597.jpg";